export interface SentryContext {
    app_mode: string;
    parent_type?: string;
}

const state: {value: SentryContext} = {value: {app_mode: "unknown"}};

export function setSentryContext(ctx: SentryContext): void {
    state.value = ctx;
}

export function getSentryContext(): SentryContext {
    if (state.value.app_mode !== "unknown") return state.value;

    if (typeof window !== "undefined" && window.location.pathname.startsWith("/webform")) {
        return {app_mode: "webform"};
    }
    return state.value;
}
